import {
  VariantColorsResolver,
  defaultVariantColorsResolver,
  parseThemeColor,
  rem,
} from '@mantine/core';

const variantColorResolver: VariantColorsResolver = (input) => {
  const defaultResolvedColors = defaultVariantColorsResolver(input);
  const parsedColor = parseThemeColor({
    color: input.color || input.theme.primaryColor,
    theme: input.theme,
  });
  const resolver = { ...defaultResolvedColors };

  /**
   * Filled Variants
   */
  if (input.variant === 'filled') {
    // if (parsedColor.color === 'cerise') {
    //   resolver.background = `var(--mantine-color-${parsedColor.color}-7)`;
    // } else {

    // }
    resolver.background = parsedColor.value;
    resolver.hover = `var(--mantine-color-${parsedColor.color}-8)`;
  }

  if (input.variant === 'outline') {
    // if (parsedColor.color === 'cerise') {
    //   resolver.color = `var(--mantine-color-${parsedColor.color}-7)`;
    //   resolver.border = `${rem(1)} solid var(--mantine-color-${parsedColor.color}-7)`;
    // } else {

    // }
    resolver.color = parsedColor.value;
    resolver.border = `${rem(1)} solid ${parsedColor.value}`;
    resolver.background = `transparent`;

    resolver.hover = `var(--mantine-color-${parsedColor.color}-0)`;
  }

  if (input.variant === 'subtle') {
    // if (parsedColor.color === 'cerise') {
    //   resolver.color = `var(--mantine-color-${parsedColor.color}-7)`;
    // }
    resolver.background = `transparent`;
    resolver.hover = `var(--mantine-color-${parsedColor.color}-0)`;
    resolver.color = parsedColor.value;
  }

  if (input.variant === 'white') {
    if (parsedColor.color === 'gray') {
      resolver.color = `var(--mantine-color-${parsedColor.color}-8)`;
    }
  }

  if (input.variant === 'gradient') {
    resolver.color = 'var(--mantine-color-gray-8)';
    resolver.background = `linear-gradient(246deg,#ffa064 0.35%,#ff9864 29.15%, #ff8264 99.92%,#ff8264 100%)`;
    resolver.hover = `var(--mantine-color-tangerine-5)`;
  }
  if (input.variant === 'gray') {
    resolver.background = `var(--mantine-color-gray-0)`;
    resolver.border = `${rem(1)} solid var(--mantine-color-gray-1)`;
    resolver.hover = `var(--mantine-color-gray-1)`;
    resolver.color = `var(--mantine-color-gray-6)`;
    resolver.hoverColor = `var(--mantine-color-gray-8)`;
  }

  if (parsedColor.color === 'cerise') {
    if (input.variant === 'filled') {
      resolver.background = `var(--mantine-color-${parsedColor.color}-7)`;
    }
    if (input.variant === 'outline') {
      resolver.color = `var(--mantine-color-${parsedColor.color}-7)`;
      resolver.border = `${rem(1)} solid var(--mantine-color-${parsedColor.color}-7)`;
    }
    if (
      input.variant === 'subtle' ||
      input.variant === 'light' ||
      input.variant === 'white' ||
      input.variant === 'transparent'
    ) {
      resolver.color = `var(--mantine-color-${parsedColor.color}-7)`;
    }
  }

  if (parsedColor.color === 'white') {
    if (input.variant === 'filled' || input.variant === 'white') {
      resolver.color = `var(--mantine-color-gray-8)`;
      resolver.hoverColor = `var(--mantine-color-cobalt-6)`;
    }
    if (input.variant === 'outline' || input.variant === 'subtle') {
      resolver.hover = 'rgba(255, 255, 255, 0.12)';
    }
  }

  return resolver;
};

export { variantColorResolver };
